import { PERSISTED_SLICES, pickPersisted } from '../settingsPersistenceConfig';

// Last subset written per slice, so we only touch localStorage when a persisted
// preference actually changes — NOT on every filter toggle or progress tick a
// tab fires while working (fixMetadata alone dispatches many during a scan).
const lastPersisted = {};

function persistTabSettings(state, sliceName) {
    const cfg = PERSISTED_SLICES[sliceName];
    if (!cfg) return;
    const subset = JSON.stringify(pickPersisted(state[sliceName], cfg.keys));
    if (lastPersisted[sliceName] === subset) return;
    lastPersisted[sliceName] = subset;
    try {
        localStorage.setItem(cfg.storageKey, subset);
    } catch (e) {
        // Best-effort — a full/again-unavailable store shouldn't break the app.
    }
}

const settingsMiddleware = (storeAPI) => (next) => (action) => {
    const result = next(action);
    const type = typeof action?.type === 'string' ? action.type : '';

    if (type === 'settings/updateSettings') {
        // Persist theme to localStorage for instant load on next startup.
        // The server write does NOT happen here — three call sites trigger
        // updateSettings({theme}) and only one is a real user choice:
        //   1. App boot reads `mixgoat-theme` from localStorage  ← cache
        //   2. loadPreferences applies the server value           ← server
        //   3. UserMenu toggle is the actual user changing intent ← user
        // If the server write fired on (1), the stale local cache would
        // race the network and overwrite the real server value on every
        // launch. Server write lives at the toggle site itself.
        const { theme } = storeAPI.getState().settings;
        localStorage.setItem('mixgoat-theme', theme);
    }

    // Persist any registered tab-settings slice whenever it changes. Skip the
    // startup hydrate so we don't immediately re-write what we just loaded.
    const sliceName = type.split('/')[0];
    if (PERSISTED_SLICES[sliceName] && !type.endsWith('/hydrate')) {
        persistTabSettings(storeAPI.getState(), sliceName);
    }

    return result;
};

// Save all settings to localStorage on app close
window.addEventListener('beforeunload', () => {
    try {
        const state = window.__reduxStore?.getState()?.settings;
        if (state) {
            localStorage.setItem('appSettings', JSON.stringify(state));
        }
    } catch (e) {
        // Ignore errors during shutdown
    }
});

export default settingsMiddleware;
